module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-3-s-063135e0406c80ae7d6916a6f71eb203.jpg";